import type { EasCustomAuthPlugin } from '@easihub/server-side/auth';
import type { BetterAuthClientPlugin } from 'better-auth';

export function customEasAuthClientPlugin() {
  return {
    id: 'custom-eas',
    $InferServerPlugin: {} as EasCustomAuthPlugin,
    fetchPlugins: [
      {
        id: 'oauth-query-signature-refresh',
        name: 'oauth-query-signature-refresh',
        hooks: {
          onRequest: async context => {
            if (!context.body)
              return;

            const body = JSON.parse(context.body);
            const oauth_query = body.oauth_query as string | undefined;
            if (!oauth_query)
              return;

            {
              const href = typeof context.url === 'string' ?
                context.url :
                context.url.href;
              const path = href.replace(context.baseURL || '', '');

              if (OAUTH_QUERY_DENYLIST.has(path)) {
                delete body.oauth_query;
                context.body = JSON.stringify(body);
                return;
              }
            }

            const fromContext = new URLSearchParams(oauth_query);
            const exp = Number.parseInt(fromContext.get('exp') || '') * 1000;
            const expired = exp < Date.now();
            if (!expired)
              return;

            // TODO: ignore if session exists

            // strip the expired signature → back to the raw authorize params
            fromContext.delete('sig');
            fromContext.delete('exp');

            // re-authorize: the OP re-validates the params (registered
            // redirect_uri, allowed scope, real client) and re-signs. Going
            // through /authorize — never re-signing here — keeps this a
            // legitimate refresh, not a signing oracle. `accept: application/json`
            // returns `{ url }` instead of a 302, so nothing navigates.
            const authorize = new URL(`${context.baseURL}/oauth2/authorize`);
            authorize.search = fromContext.toString();

            const res = await fetch(authorize, {
              headers: { accept: 'application/json' },
            });
            const resigned = await res.json()
              .then(res => new URL(res.url, context.baseURL));

            body.oauth_query = resigned.search.slice(1);

            context.body = JSON.stringify(body);

            const current = new URL(location.href);
            resigned.searchParams.forEach((value, key) => {
              current.searchParams.set(key, value);
            });
            history.replaceState(null, '', current);
          }
        }
      },
    ],
    pathMethods: {
      '/is-email-available': 'POST',
      '/is-email-provider-free': 'POST',
      '/sign-up/social-prefill': 'GET',
      '/sign-up/metadata': 'GET',
      '/sign-up/oauth2/continue': 'POST',
      '/sign-up/continue-setup/profile': 'POST',
      '/sign-up/continue-setup/discourse': 'POST',
      //   '/sign-up/finish-setup': 'POST',
    }
  } satisfies BetterAuthClientPlugin;
}

const OAUTH_QUERY_DENYLIST = new Set([
  '/is-username-available',
  '/is-email-available',
  '/is-email-provider-free',
  '/get-session',
  '/email-otp/send-verification-otp',
  '/email-otp/check-verification-otp',
  // …paths you know never consume the signed query

  // Social-signup user creation. If the signed query were sent, it would
  // populate the oauth-provider's oauth state, and because this endpoint sets a
  // session cookie, the plugin's session-cookie `after` hook would auto-run
  // /oauth2/authorize with `prompt=create` still set and redirect the window
  // straight back to /sign-up. We suppress that here so no redirect fires;
  // instead the client navigates to /sign-up/setup itself (preserving the signed
  // query), and the oauth flow resumes from there via oauth2.continue({ created: true }).
  '/sign-up/oauth2/continue'
]);